export default __webpack_public_path__ + "static/media/logoblack.56b778af.png";